import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getCardStyles = (theme: Theme): SerializedStyles =>
    css({
        ...theme.getCardStyle(),

        marginBottom: theme.spacing(2),
        padding: theme.spacing(3),
        border: `1px solid ${theme.palette.gray.light}`,
    });

export const getCardHeadingStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        justifyContent: 'normal',
        marginBottom: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.gray.light}`,
    });

export const getCardHeadingIconStyles = (theme: Theme): SerializedStyles =>
    css({
        marginRight: theme.spacing(3),
        color: theme.palette.gray.light,
    });
